// src/js/main.js - Minimal entry for instant home load. Heavy app loads via app-init.js.
import '../css/main.css';
import '../css/style.css';
import '../css/enhanced-nav.css';
import '../css/search.css';
// Bootstrap: loaded from CDN in index.html so we don't bundle it here.

// Service worker disabled for now (was causing "StrategyHandler" hangs).
// For users who already have an old SW installed, proactively unregister + clear SW caches.
async function disableServiceWorkerIfPresent() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  } catch (_) {}
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (_) {}
}
disableServiceWorkerIfPresent();

document.addEventListener('DOMContentLoaded', () => {
  const scheduleIdleWork = (cb, { timeout = 1000, fallbackDelay = 500 } = {}) => {
    if ('requestIdleCallback' in window) {
      return window.requestIdleCallback(cb, { timeout });
    }
    return window.setTimeout(cb, fallbackDelay);
  };

  const cancelIdleWork = (id) => {
    if (typeof id !== 'number') return;
    if ('cancelIdleCallback' in window) {
      window.cancelIdleCallback(id);
    } else {
      window.clearTimeout(id);
    }
  };

  // Defer non-critical setup to reduce JavaScript parsing time
  scheduleIdleWork(() => {
    import('./app-init.js').then((m) => m.init()).catch((err) => {
      console.error('App init failed:', err);
      const converterContainer = document.getElementById('converterContainer');
      if (converterContainer) {
        converterContainer.innerHTML = '<div class="alert alert-danger">Failed to load. <a href="">Refresh</a></div>';
      }
    });
  }, { timeout: 1000, fallbackDelay: 500 });

  // Load analytics after idle or first interaction
  const scheduleAnalytics = () => {
    let loaded = false;
    const load = () => {
      if (loaded) return;
      loaded = true;
      import('./analytics.js').catch(() => {});
    };

    const idleId = scheduleIdleWork(load, { timeout: 3000, fallbackDelay: 2000 });
    const onFirstInteraction = () => {
      load();
      cancelIdleWork(idleId);
      window.removeEventListener('pointerdown', onFirstInteraction);
      window.removeEventListener('keydown', onFirstInteraction);
      window.removeEventListener('scroll', onFirstInteraction);
    };

    window.addEventListener('pointerdown', onFirstInteraction, { once: true, passive: true });
    window.addEventListener('keydown', onFirstInteraction, { once: true });
    window.addEventListener('scroll', onFirstInteraction, { once: true, passive: true });
  };

  scheduleAnalytics();

  const el = document.getElementById('currentYear');
  if (el) el.textContent = new Date().getFullYear();

  const burgerBtn = document.getElementById('burgerMenuBtn');
  const offcanvasMenu = document.getElementById('offcanvasMenu');
  const closeBtn = offcanvasMenu?.querySelector('.offcanvas-close');
  let overlay = document.getElementById('offcanvasOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'offcanvasOverlay';
    document.body.appendChild(overlay);
  }
  function openMenu() {
    offcanvasMenu?.classList.add('open');
    overlay?.classList.add('show');
  }
  function closeMenu() {
    offcanvasMenu?.classList.remove('open');
    overlay?.classList.remove('show');
  }
  if (burgerBtn) burgerBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="/blog/"]');
    if (link) {
      const linkText = link.textContent.trim() || link.title || 'Blog Link';
      const linkUrl = link.href;
      const source = e.target.closest('.list-group') ? 'sidebar' : e.target.closest('footer') ? 'footer' : e.target.closest('header') ? 'header' : 'unknown';
      try {
        import('./analytics.js').then(({ trackBlogLinkClick }) => {
          trackBlogLinkClick(linkText, linkUrl, source);
        }).catch(() => {
          window.dispatchEvent(new CustomEvent('blog_link_clicked', { detail: { linkText, linkUrl, source } }));
        });
      } catch (_) {}
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  function setupCollapsible(buttonSelector, contentId, iconId) {
    const button = document.querySelector(buttonSelector);
    const content = document.getElementById(contentId);
    const icon = document.getElementById(iconId);
    if (!button || !content) return;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isCollapsed = content.classList.contains('show');
      if (isCollapsed) {
        content.classList.remove('show');
        if (icon) {
          icon.classList.remove('bi-chevron-down');
          icon.classList.add('bi-chevron-right');
        }
      } else {
        content.classList.add('show');
        if (icon) {
          icon.classList.remove('bi-chevron-right');
          icon.classList.add('bi-chevron-down');
        }
      }
    });
    if (icon) {
      icon.classList.remove('bi-chevron-right');
      icon.classList.add('bi-chevron-down');
    }
  }
  setupCollapsible('[data-bs-target="#recentlyUsedCollapse"]', 'recentlyUsedCollapse', 'recentlyUsedIcon');
  setupCollapsible('[data-bs-target="#favoritesCollapse"]', 'favoritesCollapse', 'favoritesIcon');
});
